var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sidebar-menu-page-small", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPageSmall,
            expression: "isPageSmall"
          }
        ],
        attrs: {
          downloadUrl: _vm.downloadUrl,
          downloadUrlV2: _vm.downloadUrlV2
        },
        on: {
          handleTogglePageSmallMenu: _vm.handleTogglePageSmallMenu,
          doLogout: _vm.doLogout
        }
      }),
      _vm._v(" "),
      _c("sidebar-menu-page-large", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isPageSmall,
            expression: "!isPageSmall"
          }
        ],
        attrs: {
          downloadUrl: _vm.downloadUrl,
          downloadUrlV2: _vm.downloadUrlV2
        },
        on: {
          doLogout: _vm.doLogout,
          handleToggleSideMenu: _vm.handleToggleSideMenu
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c478414a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c478414a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = null
// module chunks = 